/**
 * Custom Test Types (056) — pure ordering for a Program's enabled test
 * catalog. Rows are test_types fields plus a `program_sort_order`
 * (program_test_types.sort_order, nullable — no UI sets it yet in this
 * phase, but the comparator already honors it when present so a future
 * "reorder my Program's tests" feature needs no new sort logic here).
 *
 * Order: program_sort_order ascending when set (rows with an explicit
 * override sort before any that don't), then test_types.sort_order,
 * then display_name — the same fallback chain already implied by
 * test_types' own sort_order/display_name columns.
 */
export function compareEnabledTestTypes(a, b) {
  const aHas = a.program_sort_order !== null && a.program_sort_order !== undefined;
  const bHas = b.program_sort_order !== null && b.program_sort_order !== undefined;

  if (aHas && bHas && a.program_sort_order !== b.program_sort_order) {
    return a.program_sort_order - b.program_sort_order;
  }
  if (aHas && !bHas) return -1;
  if (!aHas && bHas) return 1;

  if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
  return (a.display_name || '').localeCompare(b.display_name || '');
}

/** Sorts a copy of the given rows — never mutates the input array. */
export function sortEnabledTestTypes(rows) {
  return [...(rows || [])].sort(compareEnabledTestTypes);
}
